/**
 * 能源管理
 */
import http from '@/request/http'
export default {
  /*** 首页 ***/
  // 本月累计降碳/减排
  carbonReduction: params => http.get(`/api/plugins/statistics/findEmissionReduction`, params),
  // 区域耗能/部门耗能/电耗分项
  energyConsumption: params => http.get(`/api/plugins/statistics/findRankByLabel`, params),
  // 能源管理首页-当天当月-用电-用气-用水-再生资源
  statisticalData: params => http.get(`/api/plugins/statistics/findHomePageECAndFLOWAndPV`, params),
  // 能源管理首页-电环比-水环比-气环比（图表）
  growthListData: params => http.get(`/api/plugins/statistics/findRatioYearToYear`, params),
  // 资产列表
  asseList: params => http.get(`/api/juji/assets/tree`, params),
  // 根据资产id获取资产下设备列表
  getDeviceLisy: params => http.get(`/api/juji/device/getDevicesByAsset`, params),
  getEnergyConsumptionSummary: params => http.get(`/api/report/energyConsumption/getEnergyConsumptionSummary`, params),
  getMainPageReduce: params => http.get(`/api/report/energyConsumption/getMainPageReduce`, params),
  // 能源结构
  getECStructureList: params => http.get(`/api/report/energyConsumption/getEnergyResourceStructure`, params),

  /*** 能耗查询 ***/
  // 能耗--电水 图表
  energyElectricTable: params => http.get(`/api/juji/energyConsumptionQuery/getDeviceList`, params),
  // 电费分段
  energyGetSubsection: params => http.get(`/api/plugins/statistics/getCostPeriodTimeAndPrice`, params),
  // 能耗排名
  energyRanking: params => http.get(`/api/plugins/statistics/findAssetRankByLabel`, params),

  /*** 同比分析 ***/
  energyRoyChart: params => http.get(`/api/juji/yearOnYear/getYearOnYearChart`, params),
  energyRoyAnalysis: params => http.get(`/api/juji/yearOnYear/getYearOnYearStatistics`, params),
  energyRoyTable: params => http.get(`/api/juji/yearOnYear/getYearOnYearList`, params),

  /*** 环比分析 ***/
  energyRingAnalysis: params => http.get(`/api/juji/monthOnMonth/getMonthOnMonthStatistics`, params),
  energyRingTable: params => http.get(`/api/juji/monthOnMonth/getMonthOnMonthList`, params),


  /*** 设备能耗 ***/
  equipmentEnergyGetList: params => http.post(`/api/juji/additionalEnergyDevice/getDevicesByTypes`, params),
  equipmentEnergyBarDataList: params => http.post(`/api/juji/additionalEnergyDevice/getEnergyRanking`, params),
  equipmentEnergyNewCharts: params => http.get(`/api/juji/additionalEnergyDevice/getEnergyCharts`, params),
  equipmentEnergyLineDataList: params => http.get(`/api/juji/additionalEnergyDevice/getCharts`, params),


  equipmentEnergyMenu: params => http.get(`/api/plugins/statistics/findSubAssetsByIdAndLabel`, params),

  /*** 运行时间 ***/
  energyRunningTime: params => http.get(`/api/juji/runningTimeStatistics/getTopLevelSubSystems`, params),
  energyRunningTimeTable: params => http.get(`/api/juji/runningTimeStatistics/getRunTimeList`, params),
  energyRunningChartsData: params => http.get(`/api/juji/runningTimeStatistics/getRunTimeCharts`, params),


  /*** 异常用能***/
  energyAbnormalTable: params => http.get(`/api/juji/abnormalEnergyUse/findMainPageList`, params),
  energyAbnormalLineData: params => http.get(`/api/juji/abnormalEnergyUse/findMainPageCharts`, params),


  /*** 能耗桑基图 ***/
  energySankeyData: params => http.get(`/api/juji/relation/sanGiTree`, params),

  /*** 新增用能***/
  energyAddOverview: params => http.get(`/api/juji/newEnergyConsumption/getOverview`, params),
  energyAddEC: params => http.get(`/api/juji/newEnergyConsumption/getEnergyConsumption`, params),
  energyAddECCharts: params => http.get(`/api/juji/newEnergyConsumption/getNewEnergyChart`, params),
  energyAddList: params => http.get(`/api/juji/newEnergyConsumption/getNewEnergyList`, params),
  energyAddECTop: params => http.get(`/api/juji/newEnergyConsumption/getNewEnergyRanking`, params),

  /*** 光伏管理***/
  energyPhotovolList: params => http.get(`/api/juji/photovoltaic/getBasicInfo`, params),

  /*** 能源管理获取中间图***/
  EMGetPic: (params, projectId) => http.get(`api/plugins/telemetry/ASSET/${projectId}/values/attributes`, params), 

  /*** 用能集抄***/
  ECMRTableData: params => http.post(`/api/juji/energyConsumptionQuery/getEnergyIntensiveReading`, params), 

}